import axios from 'axios';
import { baseURL } from './sources';

const api = axios.create({
  baseURL: baseURL
});

// Interceptor para añadir el token a cada solicitud
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

export default api;
